// extracted by mini-css-extract-plugin
export default {"faqTitle":"faq_faqTitle__yinfR"};